import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AuthContext } from '../../context/AuthContext';
import {
  // HomeIcon,
  // SearchIcon,
  CreateIcon,
  PuzzleIcon,
  MenuIcon,
} from '../icons/FeedIcons';

function NavItem({
  to, icon: Icon, label, filled = false,
}) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) => `flex items-center gap-4 p-3 rounded-lg transition-colors hover:bg-puzzle-hover ${isActive ? 'font-bold' : ''}`}
    >
      {({ isActive }) => (
        <>
          <Icon filled={isActive || filled} className="w-6 h-6" />
          <span className="hidden xl:block">{label}</span>
        </>
      )}
    </NavLink>
  );
}

NavItem.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  filled: PropTypes.bool,
};

NavItem.defaultProps = {
  filled: false,
};

function DesktopSidebar() {
  const { user } = useContext(AuthContext);

  return (
    <aside className="hidden md:flex fixed left-0 top-0 h-screen w-sidebar-collapsed xl:w-sidebar flex-col border-r border-puzzle-border bg-puzzle-surface z-40">
      {/* Logo */}
      <div className="p-4 pt-8 pb-6">
        <NavLink to="/feed" className="flex items-center gap-3">
          <svg
            className="h-8 w-8 text-puzzle-text"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z"
            />
          </svg>
          <span className="hidden xl:block text-xl font-semibold text-puzzle-text">
            Picture Puzzle
          </span>
        </NavLink>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 space-y-1">
        {/* <NavItem to="/feed" icon={HomeIcon} label="Home" /> */}
        {/* <NavItem to="/feed" icon={SearchIcon} label="Search" /> */}
        <NavItem to="/create" icon={CreateIcon} label="Create" />
        <NavItem to="/my-puzzles" icon={PuzzleIcon} label="My Puzzles" />
      </nav>

      {/* Bottom section */}
      <div className="p-3 border-t border-puzzle-border">
        {user ? (
          <NavLink
            to="/profile/demo_user"
            className="flex items-center gap-4 p-3 rounded-lg hover:bg-puzzle-hover transition-colors"
          >
            <div className="w-6 h-6 rounded-full bg-puzzle-muted flex items-center justify-center text-xs font-semibold text-puzzle-text-secondary">
              {user.email?.charAt(0).toUpperCase() || 'U'}
            </div>
            <span className="hidden xl:block text-sm">Profile</span>
          </NavLink>
        ) : (
          <NavLink
            to="/login"
            className="flex items-center gap-4 p-3 rounded-lg hover:bg-puzzle-hover transition-colors"
          >
            <div className="w-6 h-6 rounded-full bg-puzzle-muted" />
            <span className="hidden xl:block text-sm">Log in</span>
          </NavLink>
        )}
        <button
          type="button"
          className="flex items-center gap-4 p-3 rounded-lg hover:bg-puzzle-hover transition-colors w-full text-left"
        >
          <MenuIcon className="w-6 h-6" />
          <span className="hidden xl:block">More</span>
        </button>
      </div>
    </aside>
  );
}

export default DesktopSidebar;
